import { typographyTokens } from '../../theme/typographyTokens';
//TODO:  include test

import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Switch,
  Typography,
  useTheme,
  Autocomplete,
  TextField as TextFieldForLookup,
  FormLabel,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Link,
  TextField as MuiTextField,
  FormControl,
  InputLabel,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import YesNo from '../../components/YesNo';
import {
  DataFieldType,
  DataFieldUpdate,
  DataFieldWithOptionsAndLocations,
  DataFieldWithOptionsAndSingleLocation,
} from '../../../shared/types/DataField';
import TextField from '../../components/TextField';
import { useSearchUsersQuery } from '../../services/usersSlice';
import { User } from '../../../shared/types/User';
import { debounce } from 'lodash';
import RichTextEditor from '../../components/RichTextEditor/RichTextEditor';

//Datafield Components
import { Select, TileSelect, ApmSearchComponent } from '../../components/DataFields';
import { showSnackbar } from '../../../frontend/utils/snackbar';
import { useDispatch } from 'react-redux/es/hooks/useDispatch';
import { SEP_LIMIT_MAX_CHARACTERS, SEP_LIMIT_ERROR_MESSAGE, SEP_LIMIT_ALERT_DURATION,URL_NAME, TRM_DATAFIELDS_ERROR_MESSAGE } from '../../../frontend/utils/sharedConstants';

interface DataFormProps {
  dataFields:
    | DataFieldWithOptionsAndSingleLocation[]
    | DataFieldWithOptionsAndLocations[];
  data: DataFieldUpdate[];
  setData: React.Dispatch<React.SetStateAction<DataFieldUpdate[]>>;
  locationID?: number;
  knockout?: boolean;
  setDataChanged?: React.Dispatch<React.SetStateAction<boolean>>;
  sepDetails?: boolean;
  currentDepartmentID?: number;
  currentSubTab?: string;
  sepID?:number;
  setApmId?:React.Dispatch<React.SetStateAction<number>>;
  currentScreen?: any;
  sepData?: any;
  alignment?: 'left' | 'center' | 'right';
}

function isValidEmail(email: DataFieldType.email) {
  return !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
}
const DataForm: React.FC<DataFormProps> = ({
  dataFields,
  data,
  setData,
  knockout,
  sepDetails,
  currentDepartmentID,
  currentSubTab,
  setDataChanged,
  sepID,
  setApmId,
  currentScreen,
  sepData,
  alignment = 'left'
}) => {
  const dispatch = useDispatch();    
  const [DataFields, setDataFields] = useState<any[]>([]);
  const [searchTerms, setSearchTerms] = useState<Record<number, string>>({});
  const [activeFieldId, setActiveFieldId] = useState<number | null>(null);
  const [userOptions, setUserOptions] = useState<User[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showTestDialog, setShowTestDialog] = useState(false);
  const [testKeyword, setTestKeyword] = useState('test');
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  // Helper to check for test names ("test" or "testing")
  // Returns the matched keyword (case preserved) or null
  const isTestName = (name: string) => {
    const currentOrigin = window.location.origin.replace(/\/$/, '').toLowerCase();
    const urlNameNormalized = URL_NAME.replace(/\/$/, '').toLowerCase();
    // Only block test names on production
    if (currentOrigin === urlNameNormalized) {
      const regex = /(test)/i;
      const match = name.match(regex);
      return match ? match[0] : false;
    }
    // Allow test names everywhere else
    return false;
  };

  const activeSearchTerm = activeFieldId !== null ? (searchTerms[activeFieldId] || '') : '';
  
  const { data: searchResults = [], isLoading, isError, error } = useSearchUsersQuery(
    {
      search: activeSearchTerm,
      
    },
    { skip: activeSearchTerm.trim() === '' }
  ); 

  const debouncedSearch = useRef<ReturnType<typeof debounce>>(debounce((fieldId: number, term: string) => {
    setSearchTerms(prev => ({ ...prev, [fieldId]: term }));
  }, 100));
  useEffect(() => {
    return () => debouncedSearch.current.cancel();
  }, []);
  useEffect(() => {
    if (!isLoading && !isError) {
      setUserOptions((prevOptions) => {
        return JSON.stringify(prevOptions) !== JSON.stringify(searchResults) ? searchResults : prevOptions;
      });
    }
  }, [searchResults, isLoading, isError]);

  const [desVal, setDesVal] = useState('');
  
  //YesNo CHANGE EVENT
  const handleChange = useCallback(
    (e: any, fieldId: number) => {
      if (setDataChanged !== undefined) setDataChanged(true);
      const { value } = e.target;
      let newData: any = [...data];

      const index = newData.findIndex((object: any) => object.id === fieldId);

      if (newData.length > 0) {
        if (index === -1) {
          newData.push({ id: fieldId, value: value });
        } else {
          newData = data.map((dataFieldValue: any) =>
            dataFieldValue.id === fieldId
              ? { ...dataFieldValue, value: value }
              : dataFieldValue
          );
        }
        setData(newData);
      } else {
        newData.push({ id: fieldId, value: value });
        setData(newData);
      }
    },
    [data, setData, setDataChanged]
  );
  const handleChangeEmailLookup = useCallback(
    (value: any, fieldId: number) => {
      if (setDataChanged !== undefined) setDataChanged(true);
      
      let newData: any = [...data];

      const index = newData.findIndex((object: any) => object.id === fieldId);

      if (newData.length > 0) {
        if (index === -1) {
          newData.push({ id: fieldId, value: value });
        } else {
          newData = data.map((dataFieldValue: any) =>
            dataFieldValue.id === fieldId
              ? { ...dataFieldValue, value: value }
              : dataFieldValue
          );
        }
        setData(newData);
      } else {
        newData.push({ id: fieldId, value: value });
        setData(newData);
      }
    },
    [data, setData, setDataChanged]
  );
  const handleBoolValue = useCallback(
    (e: any, fieldId: number) => {
      if (setDataChanged !== undefined) setDataChanged(true);
      const { checked } = e.target;
      let newData: any = [...data];

      const index = newData.findIndex((object: any) => object.id === fieldId);

      if (newData.length > 0) {
        if (index === -1) {
          newData.push({ id: fieldId, value: checked });
        } else {
          newData = data.map((dataFieldValue: any) =>
            dataFieldValue.id === fieldId
              ? { ...dataFieldValue, value: checked }
              : dataFieldValue
          );
        }
        setData(newData);
      } else {
        newData.push({ id: fieldId, value: checked });
        setData(newData);
      }
    },
    [data, setData, setDataChanged]
  );

const handleRichTextChange = (val: any, fieldId: any) => {
  setDesVal(val)
  let newData: any = [...data];

      const index = newData.findIndex((object: any) => object.id === fieldId);

      if (newData.length > 0) {
        if (index === -1) {
          newData.push({ id: fieldId, value: val });
        } else {
          newData = data.map((dataFieldValue: any) =>
            dataFieldValue.id === fieldId
              ? { ...dataFieldValue, value: val }
              : dataFieldValue
          );
        }
        setData(newData);
      } else {
        newData.push({ id: fieldId, value: val });
        setData(newData);
      }
    
}
  //YesNo VALUE
  const handleValue = useCallback(
    (id: number) => {
      if (data.length > 0) {
        const item: any = data.find((val: any) => val.id === id);
        if (item && item.hasOwnProperty('value')) return item.value;
        return null;
      }
      return null;
    },
    [data]
  );

  const handleEmailLookupValue = useCallback(
    (id: number) => {
      if (DataFields?.length > 0) {
        const item: any = DataFields.find((val: any) => val.id === id);
        if (item && item.hasOwnProperty('value')) return item.value;
        return null;
      }
      return null;
    },
    [DataFields]
  );
  const handleApmIdChange = useCallback(
    (apm: number) => {
      
      if (setApmId){
        if (setDataChanged !== undefined) setDataChanged(true);
      const apmId  = apm? apm : 0
      setApmId(apmId)
      }
    },
    [setDataChanged]
  );

  useEffect(() => {
    setDataFields(dataFields);
  }, [data, dataFields]);

  const apmData = sepData?.apmData ? JSON.parse(sepData.apmData) : null;

  const trmToApmMapping: { [key: string]: string } = {
    "TRM Data Classification": "data_classification",
    "TRM Compliance Flag": "u_compliance_flag",
    "TRM PII": "u_pii",
    "TRM PI": "u_pi",
    "TRM Additional Regulatory Requirement":
      "u_additional_regulatory_requirement",
  };

  // Helper function to handle all TRM field updates
  const updateTrmField = (field: any, apmData: any, trmToApmMapping: any) => {
    const isTrmField = field?.name?.startsWith("TRM");
    const apmFieldKey = isTrmField ? trmToApmMapping[field.name] : null;
    const isTrmDataField = isTrmField && apmData && apmFieldKey;
    if (isTrmField && apmData && apmFieldKey) {
      return {
        ...field,
        dataFieldOptions: field?.dataFieldOptions?.map((option: any) => {
          const apmValues =
            apmData[apmFieldKey]?.split(",").map((v: string) => v.trim()) || [];
          return {
            ...option,
            selected: apmValues?.includes(option?.value),
          };
        }),
        value: apmData[apmFieldKey] || field?.value,
        isTrmDataField,
      };
    }
    return field;
  };

  // function to handle TRM field error message on readOnly click
  const handleTrmFieldClick = (isTrmReadOnly: boolean, dispatch: any) => {
    if (isTrmReadOnly) {
      showSnackbar(
        dispatch,
        {
          errorMessage:
            TRM_DATAFIELDS_ERROR_MESSAGE,
        },
        "error",
        SEP_LIMIT_ALERT_DURATION
      );
    }
  };

  return (
    <Box>
      <SepDetails sepDetails={sepDetails} dataFields={dataFields} />
      {/* {dataFields?.length === 0 && (<span></span>
        // <Typography>
        //   No data fields have been applied to this section.
        // </Typography>
      )} */}

      {!sepDetails &&
        dataFields?.map((field: any, index) => {
          // Finds if a field is required or readOnly depending on Department and access level
          const fieldProperties = knockout
            ? field.dataFieldLocation
            : field.dataFieldLocations?.find(
                (location: any) =>
                  location.locationType === currentSubTab &&
                  location.locationID === currentDepartmentID
              );
          const isTrmReadOnly = apmData && field?.name.toLowerCase().includes('trm');

          switch (field.type) {
            case 'yesNo':
              const updatedFieldYesNo = updateTrmField(field, apmData, trmToApmMapping);
              return (
                <Box 
                  onClick={() => handleTrmFieldClick(isTrmReadOnly, dispatch)}
                  sx={{ cursor: isTrmReadOnly ? 'not-allowed' : 'default' }}
                >
                <YesNo
                  field={updatedFieldYesNo}
                  value={handleValue(field.id)}
                  onChange={(e: any) => handleChange(e, field.id)}
                  readOnly={isTrmReadOnly || fieldProperties?.readOnly}
                  required={fieldProperties?.required}
                  key={field.id}
                  alignment={alignment}
                />
                </Box>
              );
            case 'emailLookup':
              const fieldSearchTerm = searchTerms[field.id] || '';
              return (
                <React.Fragment key={field.id}>
                  <div style={{width:'400px',paddingLeft:'10px'}}>
                  <FormLabel className={fieldProperties?.required ? 'required' : ''} >{field.name}</FormLabel>
                  <Autocomplete style={{paddingTop:'15px'}}
                    options={activeFieldId === field.id ? userOptions : []}
                    getOptionLabel={(user) => user.displayName || user.email || ''}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    onChange={(e, value) => {
                      
                      handleChangeEmailLookup(value?.email, field.id)
                      if (value?.email) {
                        setErrorMessage('');
                      } else {
                        setErrorMessage('Enter a valid user ID');
                      }
                    }}
                    inputValue={fieldSearchTerm}
                    onInputChange={(_, newInputValue) => {
                      setActiveFieldId(field.id);
                      debouncedSearch.current(field.id, newInputValue);
                    }}
                    onFocus={() => setActiveFieldId(field.id)}
                    renderInput={(params) => (
                      <TextFieldForLookup
                        {...params}
                        label= {handleEmailLookupValue(field.id)? handleEmailLookupValue(field.id) :"Search and Select Users"}
                        sx={{
                          borderColor: fieldSearchTerm.trim() === '' ? 'red' : 'default',
                          '& input': {
                            fontSize: typographyTokens.fontSizes.body,
                            cursor: 'pointer',
                            color: fieldSearchTerm.trim() === '' ? 'red' : 'default',
                          },
                        }}
                      />
                    )}
                  />
                 
                  </div>
                </React.Fragment>
              );
            case 'apmLookup':
              return (
                <ApmSearchComponent sepID={sepID} handleApmIdChange={handleApmIdChange}/>
              );
            case 'input':
            case 'textarea':
            case 'date':
            case 'number':
            case 'dateTime':
              const updatedFieldInput = updateTrmField(field, apmData, trmToApmMapping);
              return (
                <Box 
                  onClick={() => handleTrmFieldClick(isTrmReadOnly, dispatch)}
                  sx={{ cursor: isTrmReadOnly ? 'not-allowed' : 'default' }}
                >
                {knockout ? (
                  <MuiTextField
                  key={field.id}
                  label={field.name}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={handleValue(field.id) || ''}
                  type={
                    field.type === 'input' || field.type === 'textarea'
                      ? 'text'
                      : field.type === 'dateTime'
                      ? 'datetime-local'
                      : field.type
                  }
                  multiline={field.type === 'textarea'}
                  onChange={(e: any) => {
                    const value = e.target.value;
                    handleChange(e, field.id);
                    if (field.type === 'input' && currentScreen?.name?.includes('Name and Description') && field.name === 'Initiative Name') {
                      const testMatch = isTestName(value);
                      if (testMatch) {
                        setTestKeyword(testMatch);
                        setShowTestDialog(true);
                      }
                    }
                  }}
                  required={fieldProperties?.required}
                  InputProps={{ readOnly: isTrmReadOnly || fieldProperties?.readOnly }}
                  sx={{
                    mb: 3,
                    '& .MuiInputBase-input': { backgroundColor: '#fff' },
                  }}
                  />
                ) : <TextField
                  key={field.id}
                  field={updatedFieldInput}
                  isTrmDataField={updatedFieldInput?.isTrmDataField}
                  placeholder={!currentScreen?.name?.includes('Name and Description') ? field.description || field.name : ''}
                  type={
                    field.type === 'input' || field.type === 'textarea'
                      ? 'text'
                      : field.type === 'dateTime'
                      ? 'datetime-local'
                      : field.type
                  }
                  multiline={field.type === 'textarea'}
                  onChange={(e: any) => {
                      const value = e.target.value;
                      const isInitiativeNameInput = field.type === 'input' && currentScreen?.name?.includes('Name and Description') && field.name === 'Initiative Name';

                      if (isInitiativeNameInput) {
                        const testMatch = isTestName(value);
                        if (testMatch) {
                          setTestKeyword(testMatch);
                          setShowTestDialog(true);
                        }
                        if (value.length > SEP_LIMIT_MAX_CHARACTERS) {
                          e.target.value = value.slice(0, SEP_LIMIT_MAX_CHARACTERS);
                          showSnackbar(
                            dispatch,
                            { errorMessage: SEP_LIMIT_ERROR_MESSAGE },
                            'error',
                            SEP_LIMIT_ALERT_DURATION
                          );
                        }
                      }
                      handleChange(e, field.id);
                  }}
                  value={handleValue(field.id) || ''}
                  sx={{
                    marginLeft: field.type === 'input' && currentScreen?.name?.includes('Name and Description') ? 0 : 1,
                    width: field.type === 'input' && currentScreen?.name?.includes('Name and Description') ? '100%' : 300,
                    mr: field.type === 'input' && currentScreen?.name?.includes('Name and Description') ? 0 : 1,
                    '& .MuiInputBase-input': {
                       color: isDarkMode ? theme.palette.white.main + " !important" :  theme.palette.black.main + " !important",
                       backgroundColor: isDarkMode ? theme.palette.background.default : '#fff',
                      },
                      '& .MuiInputBase-root.Mui-focused': {
                       backgroundColor: isDarkMode ? theme.palette.background.default : '#fff',
                      },
                      '& .MuiInputBase-input::placeholder': {
                        color: isDarkMode ? theme.palette.white.main + " !important" :  theme.palette.black.main + " !important",
                        opacity: '1 !important',
                      },
                      '& .MuiInputBase-input::-webkit-input-placeholder': {
                        color: isDarkMode ? theme.palette.white.main + " !important" :  theme.palette.black.main + " !important",
                        opacity: '1 !important',
                      },
                      '& .MuiInputBase-input::-moz-placeholder': {
                        color: isDarkMode ? theme.palette.white.main + " !important" :  theme.palette.black.main + " !important",
                        opacity: '1 !important',
                      },
                    cursor: isTrmReadOnly ? 'not-allowed' : 'default',
                    pointerEvents: isTrmReadOnly ? 'none' : 'auto'
                  }}
                  required={fieldProperties?.required}
                  readOnly={isTrmReadOnly || fieldProperties?.readOnly}
                  caption ={field.type === 'input' && currentScreen?.name?.includes('Name and Description') ? field.description : ''}
                />}
                </Box>
              );
              case 'textbox' :
                return(
                  <>
                  <Typography my={2}>
                  {field?.name}
                  </Typography>
                   <RichTextEditor 
                     value={desVal} 
                     setValue={(value: any) => handleRichTextChange(value, field?.id)} 
                     style={{ height: '250px', width: '100%' }}
                     onChangeEvent={true}
                    />
                  <FormHelperText>{field?.description}</FormHelperText>
                 </>
                );
              
            case 'email':
              const value = handleValue(field.id);
              const validation =
                value !== '' && value !== null && isValidEmail(value); //&& isValidEmail(handleValue(field.id))
              return (
                <TextField
                  key={field.id}
                  field={field}
                  type="email"
                  error={validation}
                  placeholder={field.description || field.name}
                  onChange={(e: any) => handleChange(e, field.id)}
                  value={value || ''}
                  sx={{
                    marginLeft: 1,
                    width: 300,
                    mr: 1,
                  }}
                  required={fieldProperties?.required}
                  readOnly={fieldProperties?.readOnly}
                  helperText={validation && 'Not a valid email'}
                />
              );

            case 'select':
              const updatedSelectField = updateTrmField(field, apmData, trmToApmMapping);
              return (
                <Box 
                  key={field.id}
                  onClick={() => handleTrmFieldClick(isTrmReadOnly, dispatch)}
                  sx={{ cursor: isTrmReadOnly ? 'not-allowed' : 'default', display: 'flex', justifyContent: alignment, marginBottom: 2 }}
                >
                <Select
                  field={updatedSelectField}
                  index={index}
                  key={field.id}
                  data={data}
                  DataFields={DataFields}
                  setDataFields={setDataFields}
                  setData={setData}
                  setDataChanged={setDataChanged}
                  readOnly={isTrmReadOnly ||fieldProperties?.readOnly}
                  required={fieldProperties?.required}
                  isTrmDataField={updatedSelectField?.isTrmDataField}
                />
                </Box>
              );

            case 'multiSelect':
              const updatedMultiSelectField = updateTrmField(field, apmData, trmToApmMapping); 
              return (
                <Box 
                  onClick={() => handleTrmFieldClick(isTrmReadOnly, dispatch)}
                  sx={{ cursor: isTrmReadOnly ? 'not-allowed' : 'default', display: 'flex', justifyContent: alignment, marginBottom: 1 }}
                >
                <Select
                  field={updatedMultiSelectField}
                  index={index}
                  DataFields={DataFields}
                  setDataChanged={setDataChanged}
                  setDataFields={setDataFields}
                  setData={setData}
                  multiple={true}
                  key={field.id}
                  data={data}
                  readOnly={isTrmReadOnly || fieldProperties?.readOnly}
                  required={fieldProperties?.required}
                  isTrmDataField={updatedMultiSelectField?.isTrmDataField}
                />
                </Box>
              );
            case 'tileSelect':
              return knockout ? (
                <TileSelect
                  field={field}
                  index={index}
                  key={field.id}
                  data={data}
                  DataFields={DataFields}
                  setDataFields={setDataFields}
                  setData={setData}
                  setDataChanged={setDataChanged}
                />
              ) : (
                <Select
                  field={field}
                  index={index}
                  key={field.id}
                  data={data}
                  DataFields={DataFields}
                  setDataFields={setDataFields}
                  setData={setData}
                  setDataChanged={setDataChanged}
                  readOnly={fieldProperties?.readOnly}
                  required={fieldProperties?.required}
                />
              );
            case 'tileMultiSelect':
              return knockout ? (
                <TileSelect
                  field={field}
                  index={index}
                  key={field.id}
                  data={data}
                  DataFields={DataFields}
                  setDataFields={setDataFields}
                  setData={setData}
                  setDataChanged={setDataChanged}
                  multiple
                  readOnly={fieldProperties?.readOnly}
                  required={fieldProperties?.required}
                />
              ) : (
                <Select
                  field={field}
                  index={index}
                  DataFields={DataFields}
                  setDataChanged={setDataChanged}
                  setDataFields={setDataFields}
                  setData={setData}
                  multiple={true}
                  key={field.id}
                  data={data}
                  readOnly={fieldProperties?.readOnly}
                  required={fieldProperties?.required}
                />
              );
            case 'toggle':
              return (
                <Box my={2} key={field.id}>
                  <FormControlLabel
                    className={fieldProperties?.required ? 'required' : ''}
                    control={
                      <Switch
                        disabled={fieldProperties?.readOnly}
                        checked={handleValue(field.id) || false}
                        onChange={(e: any) => handleBoolValue(e, field.id)}
                      />
                    }
                    label={field.name}
                  />
                </Box>
              );
            case 'checkbox':
              return (
                <Box my={2} key={field.id}>
                  <FormControlLabel
                    className={fieldProperties?.required ? 'required' : ''}
                    control={
                      <Checkbox
                        disabled={fieldProperties?.readOnly}
                        checked={handleValue(field.id) || false}
                        onChange={(e: any) => handleBoolValue(e, field.id)}
                      />
                    }
                    label={field.name}
                  />
                </Box>
              );
            default:
              return <p>Under construction</p>;
          }
        })}
      {/* Show dialog if test name is entered */}
      <Dialog open={showTestDialog} onClose={() => setShowTestDialog(false)}>
        <div
          style={{
            backgroundColor: '#fed8d5ff',
            boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
            border: '2px solid #f5c6cb',
            
            padding: '18px',
            minWidth: '400px',
            position: 'relative',
            display: 'block',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <InfoOutlinedIcon style={{ color: '#d32f2f', fontSize: typographyTokens.fontSizes.h4, marginRight: 8 }} />
            <DialogTitle
              sx={{
                color: '#2a0505ff',
                backgroundColor: 'transparent',
                p: 0,
                fontWeight: typographyTokens.fontWeights.bold,
                fontSize: '1.1rem',
              }}
            >
              {`You named this SEP "${testKeyword}"`}
            </DialogTitle>
          </div>
          <DialogContent
            sx={{
              color: '#2a0505ff',
              backgroundColor: 'transparent',
              p: 0,
              fontSize: '1rem',
              marginTop: '4px',
              lineHeight: 1.7,
            }}
          >
            Please correct and try again. If you would like to experience the SEP intake process, please use our test environment at{' '}
            <Link
              href="https://sep-stage.constellation.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#1259cdff', textDecoration: 'underline', fontWeight: typographyTokens.fontWeights.bold, fontSize: '1rem' }}
            >
              sep-stage.constellation.com
            </Link>.
          </DialogContent>
          <DialogActions
            sx={{
              backgroundColor: 'transparent',
              p: 0,
              justifyContent: 'flex-end',
              marginTop: '16px',
            }}
          >
            <Button
              onClick={() => setShowTestDialog(false)}
              variant="contained"
              sx={{
                backgroundColor: '#ffffffff',
                color: '#2a0505ff',
                fontWeight: typographyTokens.fontWeights.bold,
                minWidth: '100px',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: '#ffffffff',
                },
              }}
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </Box>
  );
};

export default DataForm;

const SepDetails = ({ sepDetails, dataFields }: any) => {
  const theme = useTheme();
  const selectValue = (array: any) => {
    const option = array.filter((o: any) => o.selected);

    return !option.length ? (
      <p className="sep-data">{'No current answer'}</p>
    ) : (
      option.map((e: any) => (
        <Chip
          key={e.id}
          sx={{
            border: 1,
            borderColor: theme.palette.grey[400],
            borderRadius: 1,
            marginLeft: 1,
          }}
          label={e.value}
        />
      ))
    );
  };

  return (
    <>
      {sepDetails && dataFields &&
        dataFields?.map((field: any) => {
          switch (field.type) {
            case 'yesNo':
            case 'textarea':
            case 'input':
            case 'date':
            case 'number':
            case 'email':
            case 'dateTime':
              return (
                <div key={field.id}>
                  <Box>
                    <p className="sep-label" style={{ marginTop: '10px' }}>
                      {field.name}
                    </p>
                    <p className="sep-data">
                      {field.value || 'No current answer'}
                    </p>
                  </Box>
                  <br />
                  <Divider />
                </div>
              );
            case 'select':
            case 'multiSelect':
            case 'tileSelect':
            case 'tileMultiSelect':
              return (
                <div key={field.id}>
                  <Box>
                    <p className="sep-label" style={{ marginTop: '10px' }}>
                      {field.name}
                    </p>
                    {selectValue(field.dataFieldOptions)}
                  </Box>
                  <br />
                  <Divider />
                </div>
              );
            case 'toggle':
              return (
                <Box my={2} key={field.id}>
                  <FormControlLabel
                    control={
                      <Switch disabled={true} checked={field.value || false} />
                    }
                    label={field.name}
                  />
                </Box>
              );
            case 'checkbox':
              return (
                <Box my={2} key={field.id}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={true}
                        checked={field.value || false}
                      />
                    }
                    label={field.name}
                  />
                </Box>
              );
            default:
              return <p>Under construction</p>;
          }
        })}
    </>
  );
};
